<ng-container *transloco="let t; prefix: 'driverManager'">
<div class="driver-manager-settings d-flex row">
  <div class="row align-content-center driver-manager-settings__header">
    <div class="col-lg-5 align-self-center d-flex align-items-center gap-2">
      <div class="d-flex gap-2 header__title" [routerLink]="['/driver-management/driver-manager']">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z"
            fill="#9FA1A4" />
          </svg>
          <h2 class="h3 header__title-text">
            <span>{{ t('settings.title') }}</span>
          </h2>
        </div>
      </div>
    </div>

    <form class="driver-manager-settings__body" #settingsForm="ngForm" (submit)="submit()">
      <span class="info">{{ t('settings.accountPrompt') }}</span>

      <app-account-selector class="w-100" (accountChanged)="onAccountChange($event)" [positionOffset]="'-90,15'"></app-account-selector>

      <div class="setting-group">
        <h3 class="setting-group__title">
          {{ t('settings.groups.timeInYard') }}
        </h3>

        <div class="setting-group__input-row">
          <div class="setting-group__input">
            <label class="form-label">{{ t('settings.fields.checkInTime') }}</label>
            <app-duration-picker-input [(ngModel)]="driverTimerSettings.yardCheckInTimeThreshold" [required]="true"
            name="yardCheckInTimeThreshold" [disabled]="!accountId"></app-duration-picker-input>
            @if (hasDurationError('yardCheckInTimeThreshold')) {
              <div class="error-message text-danger">
                {{ t('settings.validation.checkInTimeZero') }}
              </div>
            }
          </div>

          <div class="setting-group__input">
            <label class="form-label">{{ t('settings.fields.enterVehicle') }}</label>
            <app-duration-picker-input [(ngModel)]="driverTimerSettings.yardEnterVehicleThreshold" [required]="true"
            name="yardEnterVehicleThreshold" [disabled]="!accountId"></app-duration-picker-input>
            @if (settingsForm.controls['yardEnterVehicleThreshold']?.touched
              && settingsForm.controls['yardEnterVehicleThreshold']?.errors
              && settingsForm.controls['yardEnterVehicleThreshold']?.errors!['invalidDuration']) {
              <div
                class="error-message text-danger">
                {{ t('settings.validation.enterVehicleZero') }}
              </div>
            }
          </div>
        </div>
      </div>

      <div class="setting-group">
        <h3 class="setting-group__title">
          {{ t('settings.groups.timeInVehicle') }}
        </h3>

        <div class="setting-group__input-row">
          <div class="setting-group__input">
            <label class="form-label">{{ t('settings.fields.enterVehicle') }}</label>
            <app-duration-picker-input [(ngModel)]="driverTimerSettings.vehicleEnterThreshold" [required]="true"
            name="vehicleEnterThreshold" [disabled]="!accountId"></app-duration-picker-input>
            @if (settingsForm.controls['vehicleEnterThreshold']?.touched
              && settingsForm.controls['vehicleEnterThreshold']?.errors
              && settingsForm.controls['vehicleEnterThreshold']?.errors!['invalidDuration']) {
              <div
                class="error-message text-danger">
                {{ t('settings.validation.enterVehicleZero') }}
              </div>
            }
          </div>

          <div class="setting-group__input">
            <label class="form-label">{{ t('settings.fields.exitYard') }}</label>
            <app-duration-picker-input [(ngModel)]="driverTimerSettings.vehicleExitYardThreshold" [required]="true"
            name="vehicleExitYardThreshold" [disabled]="!accountId"></app-duration-picker-input>
            @if (settingsForm.controls['vehicleExitYardThreshold']?.touched
              && settingsForm.controls['vehicleExitYardThreshold']?.errors
              && settingsForm.controls['vehicleExitYardThreshold']?.errors!['invalidDuration']) {
              <div
                class="error-message text-danger">
                {{ t('settings.validation.exitYardZero') }}
              </div>
            }
          </div>
        </div>
      </div>

      <div class="setting-group">
        <h3 class="setting-group__title">
          {{ t('settings.groups.drivingTime') }}
        </h3>

        <div class="setting-group__input-row">
          <div class="setting-group__input">
            <label class="form-label">{{ t('settings.fields.drivingTime') }}</label>
            <app-duration-picker-input [(ngModel)]="driverTimerSettings.drivingTimeThreshold" [required]="true"
            name="drivingTimeThreshold" [disabled]="!accountId"></app-duration-picker-input>
            @if (settingsForm.controls['drivingTimeThreshold']?.touched
              && settingsForm.controls['drivingTimeThreshold']?.errors
              && settingsForm.controls['drivingTimeThreshold']?.errors!['invalidDuration']) {
              <div
                class="error-message text-danger">
                {{ t('settings.validation.drivingTimeZero') }}
              </div>
            }
          </div>

          <div class="setting-group__input">
            <label class="form-label">{{ t('settings.fields.maxDailyTotal') }}</label>
            <app-duration-picker-input [(ngModel)]="driverTimerSettings.drivingTimeDailyThreshold" [required]="true"
            name="drivingTimeDailyThreshold" [disabled]="!accountId"></app-duration-picker-input>
            @if (settingsForm.controls['drivingTimeDailyThreshold']?.touched
              && settingsForm.controls['drivingTimeDailyThreshold']?.errors
              && settingsForm.controls['drivingTimeDailyThreshold']?.errors!['invalidDuration']) {
              <div
                class="error-message text-danger">
                {{ t('settings.validation.maxDailyTotalZero') }}
              </div>
            }
          </div>
        </div>
      </div>

      <div class="setting-group">
        <h3 class="setting-group__title">
          {{ t('settings.groups.stationaryTime') }}
        </h3>

        <div class="setting-group__input-row">
          <div class="setting-group__input">
            <label class="form-label">{{ t('settings.fields.offLoadingTime') }}</label>
            <app-duration-picker-input [(ngModel)]="driverTimerSettings.stationaryTimeThreshold" [required]="true"
            name="stationaryTimeThreshold" [disabled]="!accountId"></app-duration-picker-input>
            @if (settingsForm.controls['stationaryTimeThreshold']?.touched
              && settingsForm.controls['stationaryTimeThreshold']?.errors
              && settingsForm.controls['stationaryTimeThreshold']?.errors!['invalidDuration']) {
              <div
                class="error-message text-danger">
                {{ t('settings.validation.offLoadingTimeZero') }}
              </div>
            }
          </div>

          <div class="setting-group__input">
            <label class="form-label">{{ t('settings.fields.maxDailyTotal') }}</label>
            <app-duration-picker-input [(ngModel)]="driverTimerSettings.stationaryTimeDailyThreshold" [required]="true"
            name="stationaryTimeDailyThreshold" [disabled]="!accountId"></app-duration-picker-input>
            @if (settingsForm.controls['stationaryTimeDailyThreshold']?.touched
              && settingsForm.controls['stationaryTimeDailyThreshold']?.errors
              && settingsForm.controls['stationaryTimeDailyThreshold']?.errors!['invalidDuration']) {
              <div
                class="error-message text-danger">
                {{ t('settings.validation.maxDailyTotalZero') }}
              </div>
            }
          </div>
        </div>
      </div>

      <!--NOTE: Hide this for now until we are certain we don't need it-->
      <!-- <label class="idle-checkbox">
      <input class="idle-checkbox__input" name="idleTime" type="checkbox" [(ngModel)]="driverTimerSettings.idleTime" [disabled]="!accountId"/>
      Include Idle Time
    </label> -->

    <button class="btn btn-primary w-full btn-save" type="submit" [disabled]="settingsForm.invalid || !accountId">{{ 'common.saveChanges' | transloco }}</button>
  </form>
</div>
<block-ui></block-ui>
</ng-container>